/**
 * CMCD `headers` transmission mode.
 *
 *
 * @beta
 */
export const CMCD_HEADERS = 'headers'
